// extracted by mini-css-extract-plugin
export var avatarContainer = "_65-1";
export var largeAvatarContainer = "_65-2";
export var smallAvatarContainer = "_65-0";